import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuToggle,
  IonIcon,
  useIonRouter,
} from '@ionic/react';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import SellIcon from '@mui/icons-material/Sell';
import { useLocation } from 'react-router-dom';
import { getPageTitle } from '../../utils/getPageTitle';
import { SearchBar } from './SearchBar';
import { NotificationBell } from './NotificationBell';
import revLogo from '../../assets/REV_logo.svg';
import revLogoWhite from '../../assets/REV_logo_white.svg';
import hamIcon from '../../assets/ham-icon.svg';
import { CreditCard } from '@mui/icons-material';

export function MobileHeader() {
  const router = useIonRouter();
  const location = useLocation();
  const pageTitle = getPageTitle(location.pathname);

  return (
    <IonHeader>
      <IonToolbar className='bg-white'>
        <div slot="start" className="flex items-center">
          <div className="flex items-center px-4 py-4">
            <img src={revLogo} alt="REV Logo" className="h-6 w-auto dark:hidden" />
            <img src={revLogo} alt="REV Logo" className="h-6 w-auto hidden dark:block" />
          </div>
          <SignedIn>
            <IonButtons>
              <IonMenuToggle>
                <IonButton>
                  <IonIcon icon={hamIcon} className="text-l" color="medium" />
                </IonButton>
              </IonMenuToggle>
            </IonButtons>
          </SignedIn>
        </div>

        <IonButtons slot="end">
          <SignedOut>
            <IonButton onClick={() => router.push('/sign-in', 'none')}>
              Sign In
            </IonButton>
          </SignedOut>

          <SignedIn>
            <div className="flex items-center gap-2 pr-2">
              {/* TODO: Uncomment when Notification Bell feature is implemented
              <NotificationBell variant="mobile" />
              */}

              {/* User Profile */}
              <UserButton>
                <UserButton.MenuItems>
                  <UserButton.Action
                    label="Subscription"
                    labelIcon={<SellIcon sx={{ fontSize: 16 }} />}
                    onClick={() => router.push('/plans', 'none')}
                  />
                  <UserButton.Action
                    label="Billing"
                    labelIcon={<CreditCard sx={{ fontSize: 16 }} />}
                    onClick={() => router.push('/billing', 'none')}
                  />
                </UserButton.MenuItems>
              </UserButton>
            </div>
          </SignedIn>
        </IonButtons>
      </IonToolbar>

      {/* Search Bar - Centered below toolbar on mobile */}
      {/* <SignedIn>
        <div className="px-4 pb-3 pt-2">
          <SearchBar variant="mobile" />
        </div>
      </SignedIn> */}
    </IonHeader>
  );
}

